import React from 'react';
import './ResponsiveButton.css';

interface ResponsiveButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  'aria-label'?: string;
  style?: React.CSSProperties;
}

export const ResponsiveButton: React.FC<ResponsiveButtonProps> = ({
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  className = '',
  type = 'button',
  'aria-label': ariaLabel,
  style,
}) => {
  const classes = [
    'responsive-button',
    `responsive-button--${variant}`,
    `responsive-button--${size}`,
    fullWidth && 'responsive-button--full-width',
    disabled && 'responsive-button--disabled',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      style={style}
    >
      <span className="responsive-button__content">
        {children}
      </span>
    </button>
  );
};